import apiApp from "./index";
const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

const ActionsApi = {
  // Create actions Api
  CreateActions: (data) => {
    const token = localStorage.getItem("UserjwtToken");

    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .post(`/actions`, data, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  // List actions Api
  Listactions: () => {
    const token = localStorage.getItem("UserjwtToken");

    const headers = {
      Authorization: `Bearer ${token}`,
      "x-Authorization": `${decodedToken?.tenantApiKey}`,
    };
    return new Promise((resolve, reject) => {
      apiApp
        .get(`/actions?size=100&tenantId=${decodedToken?.tenantId}`, {
          headers: headers,
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
};

export default ActionsApi;
